// extracted by mini-css-extract-plugin
module.exports = {"modal":"ShareModal_modal__OeMRv","button":"ShareModal_button__2zvF6","delete":"ShareModal_delete__2g9CF"};